import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as RegistrationReceivedService from '../../../services/api/registration_received';
import * as RequestInformation from '../../../services/api/info_request';
import * as NotificationService from '../../../services/api/notification';

/** Fetch FetchREGISTRATION_RECEIVEDListInput  */

interface FetchRegistrationReceivedListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  msidCountry?: string;
  schemeType?: string;
}

class FetchRegistrationReceivedList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_REGISTRATION_RECEIVED_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_REGISTRATION_RECEIVED_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_REGISTRATION_RECEIVED_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchRegistrationReceivedListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await RegistrationReceivedService.fetchRegistrationReceivedList(
            payload
          );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetcRegistrationReceivedList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

/** View RegistrationReceived  */

interface ViewRegistrationReceivedInput {
  registration_received_id: number;
}

class ViewRegistrationReceived implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_REGISTRATION_RECEIVED_DETAIL,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_REGISTRATION_RECEIVED_DETAIL,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_REGISTRATION_RECEIVED_DETAIL,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: ViewRegistrationReceivedInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await RegistrationReceivedService.fetchRegistrationReceivedDetail({
            registration_received_id: payload.registration_received_id,
          });
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('ViewRegistrationReceived Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

interface FetchFEReceivedByRegistrationReceivedIdInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  id: number;
}

class FetchFEReceivedByRegistrationReceivedIdList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_FE_RECEIVED_BY_REGISTRATION_RECEIVED_ID,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_FE_RECEIVED_BY_REGISTRATION_RECEIVED_ID,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_FE_RECEIVED_BY_REGISTRATION_RECEIVED_ID,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchFEReceivedByRegistrationReceivedIdInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await RegistrationReceivedService.fetchFixedEstablishmentReceivedList(
            payload
          );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log(
        //   'FetchFEReceivedByRegistrationReceivedIdInput Error:',
        //   error.message
        // ); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMemberStateExcludeCyprus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState(true);
        // console.log(response.data);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateExcludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchUnreadNotificationCount implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Failed,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await NotificationService.fetchUnreadNotificationCount();
        dispatch(this.onSuccess(response.data.total));
      } catch (error: any) {
        // console.log('FetchUnreadNotificationCount Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class ClearUnreadNotificationCount implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

export default {
  fetchRegistrationReceivedListAction: (
    payload: FetchRegistrationReceivedListInput
  ) => new FetchRegistrationReceivedList().action(payload),
  viewRegistrationReceivedAction: (payload: ViewRegistrationReceivedInput) =>
    new ViewRegistrationReceived().action(payload),
  fetchFEReceivedByRegistrationReceivedId: (
    payload: FetchFEReceivedByRegistrationReceivedIdInput
  ) => new FetchFEReceivedByRegistrationReceivedIdList().action(payload),
  fetchMemberStateExcludeCyprusAction: () =>
    new FetchMemberStateExcludeCyprus().action(),
  fetchUnreadNotificationCountAction: () =>
    new FetchUnreadNotificationCount().action(),
  clearUnreadNotificationCountAction: () =>
    new ClearUnreadNotificationCount().action(),
};
